import { getAmplitudeInstance } from '../amplitudeHelpers';
import CustomRouteActionClicked from '../enums/CustomRouteActionClicked';

type logCustomRouteActionClickedParams = {
  action?: CustomRouteActionClicked;
  custom_route_id?: number;
  owned_by_user?: boolean;
};

/**
 * User takes an action with a previously created custom route. (Note: this only includes routes created via the mobile BYOT route creator, not the web custom map creator.)
 * @param params - Attributes to log with the amplitude event
 * @param params.action - The action that the user tok with a previously created custom route
 * @param params.custom_route_id - The route id of the custom route
 * @param params.owned_by_user - If the custom route is owned by the user (TRUE)
 */
const logCustomRouteActionClicked = ({ action, custom_route_id, owned_by_user }: logCustomRouteActionClickedParams, callback?: () => void) => {
  getAmplitudeInstance().logEvent(
    'custom route action clicked',
    { action, 'custom route id': custom_route_id, 'owned by user': owned_by_user },
    callback
  );
};

export default logCustomRouteActionClicked;
